import api from "./axios";
export const createFeedback = async (payload) => {
  const { data } = await api.post("common/feedback/create_feedback/", payload);
  return data;
};
